import { render, staticRenderFns } from "./app-widget.vue?vue&type=template&id=1c1513f4&functional=true&"
import script from "./app-widget.vue?vue&type=script&lang=js&"
export * from "./app-widget.vue?vue&type=script&lang=js&"
import style0 from "./app-widget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports